import MyBatchStudentDetailsTable from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailsTable";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { Card } from "antd";
import { useContext, useEffect, useState } from "react";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_BATCH_STUDENT_DETAILS,
} from "utilFunctions/Constants/urlConstants";
import { useParams } from "react-router-dom";
import { useMyBatchContext } from "Pages/MyBatches/MyBatch/Context/useMyBatchContext";

export const CustomMyBatchCard = styled<any>(Card)`
  border-top: 0px !important;
  border-radius: 0px !important;
  .ant-card-body {
    padding: ${({ screen }: any) =>
      ["xxl", "xl", "lg"].includes(screen)
        ? "0 16px 16px 0px !important"
        : "0px !important"};
    border-radius: 0px !important;
  }
`;
const MainDiv = styled<any>("div")`
  padding-right: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "0px" : "0px"};
  margin-top: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "0px" : "0px"};
`;
const MyBatchStudentDetailTab = ({ tableHeading }: any) => {
  const { id } = useParams();
  const { batchDetailsData } = useMyBatchContext();
  const [MyBatchData, setMyBatchData] = useState<any>([]);
  const ToastDispatch = useContext(ToastContextDispatch);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "50"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  const { screen }: any = useWindowSize();
  const { makeRequest: GetMyBatchData, loading: tableloading } = useGetApi(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setMyBatchData(data["data"] || []);
        setPagination((prevpagination: any) => ({
          ...prevpagination,
          total: data["totalCount"],
        }));
      } else {
        setMyBatchData([]);
      }
    },
    (error: any) => {
      setMyBatchData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    if (batchDetailsData != null) {
      const offset = (pagination.current - 1) * pagination.pageSize;
      const url = `${BASE_URL}${GET_BATCH_STUDENT_DETAILS}?stream=${batchDetailsData["academicGroup"]}&batchId=${id}&sortBy=studentName&sortDir=ASC`;
      GetMyBatchData(
        `${url}
        &offset=${offset}&limit=${pagination?.pageSize}&`
      );
    }
  }, [batchDetailsData, pagination.current, pagination.pageSize]);
  console.log("MyBatchData", MyBatchData, batchDetailsData, tableHeading);
  return (
    <CustomMyBatchCard screen={screen}>
      <MainDiv screen={screen}>
        <TableLayoutAntd isLoader={tableloading}>
          <MyBatchStudentDetailsTable
            data={MyBatchData}
            access="Batches"
            pagination={pagination}
            setPagination={setPagination}
            batchDetailsData={batchDetailsData}
          ></MyBatchStudentDetailsTable>
        </TableLayoutAntd>
      </MainDiv>
    </CustomMyBatchCard>
  );
};
export default MyBatchStudentDetailTab;
